import React, {useRef} from 'react';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Signature} from 'components/forms/fields';
import {SummaryCard} from 'components/forms/generate_cg719s/Address';
import EndSection from '../EndSection';
import PDFPreview from 'components/files/pdf/Preview';
import Joi from 'joi';

const sanitizeFunction = data => {
    const {applicant_signature, owner_signature} = data;

    return {
        applicant_signature,
        owner_signature,
    };
};

const schema = {
    applicant_signature: Joi.object({
        signed_dt: Joi.date().required(),
        user_text_input: Joi.string().required(),
    }),
    owner_signature: Joi.object({
        signed_dt: Joi.date().required(),
        user_text_input: Joi.string().required(),
    }),
};

const initialValues = {
    applicant_signature: {
        signed_dt: null,
        user_text_input: null,
    },
    owner_signature: {
        signed_dt: null,
        user_text_input: null,
    }
};

const useStyles = makeStyles(theme => ({
    pdfContainer: {
        width: '100%',
    },
    bold: {
        fontWeight: 'bold',
    },
}));

const defaultWarning = `Type your full name to sign your form as Applicant
    and Owner`;
const defaultCertification = `
    I certify that the above individual has served on the above 
    vessel as stated. I am making this statement in order that 
    the applicant may obtain a credential to operate a vessel under 
    the provisions of Title 46 CFR, as applicable. I understand that 
    if I make any false or fraudulent statement in this certification 
    of service, I may be subject to a fine or imprisonment of up to 
    five (5) years or both (18 U.S.C. 1001).`;

const SignIt = ({
    imageUrl,
    endpoint,
    buttonText,
    redirectOnSuccess,
    redirectUrl,
    ...props
}) => {
    const containerRef = useRef(null);
    const classes = useStyles();

    return (
        <EndSection
            {...props}
            schema={schema}
            initialValues={initialValues}
            endpointOverride={endpoint}
            buttonText={buttonText}
            sanitizeFunction={sanitizeFunction}
            redirectOnSuccess={redirectOnSuccess}
            redirectUrl={redirectUrl}
        >
            <SummaryCard />
            <Grid container justifyContent='center' spacing={2}>
                <Grid item xs={12} ref={containerRef} className={classes.pdfContainer}>
                    <PDFPreview
                        showControls
                        smallControls
                        file={imageUrl}
                        ref={containerRef}
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Typography variant='body1' className={classes.bold}>
                        {defaultWarning}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Signature
                        fullWidth
                        variant='outlined'
                        name='applicant_signature'
                        placeholder='Jessie B. Smith'
                        label='Applicant Signature'
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Signature
                        fullWidth
                        variant='outlined'
                        name='owner_signature'
                        placeholder='Jessie B. Smith'
                        label='Owner Signature'
                    />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Typography variant='body1'>
                        {defaultCertification}
                    </Typography>
                </Grid>
            </Grid>
        </EndSection>
    );
};

export default SignIt;
